import { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Stack,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  CircularProgress,
  Typography,
  Box,
} from "@mui/material";
import { updateAccount } from "../../../services/Admin/AccountsAdminAndUsersApi";

const ROLE_OPTIONS = [
  { value: "client", label: "client" },
  { value: "user", label: "user" },
];

const EditClientAccountDialog = ({ open, onClose, account, onSuccess }) => {
  const [loading, setLoading] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [role, setRole] = useState(ROLE_OPTIONS[0].value);
  const [type, setType] = useState("client");
  const [status, setStatus] = useState("1");
  const [error, setError] = useState("");

  useEffect(() => {
    if (open) {
      setName(account?.name || "");
      setEmail(account?.email || "");
      setPassword("");
      setRole(account?.role || account?.type || ROLE_OPTIONS[0].value);
      setType(account?.type || "client");
      setStatus(account?.status !== undefined ? String(account.status) : "1");
      setError("");
      setLoading(false);
    }
  }, [open, account]);

  const handleSubmit = async () => {
    if (!account?.id) return;
    setError("");
    if (!name.trim() || !email.trim()) {
      setError("الاسم والبريد مطلوبان");
      return;
    }

    const payload = {
      name: name.trim(),
      email: email.trim(),
      role,
      type,
      status: Number(status), // 0 = معطل ، 1 = مفعل
    };
    if (password) payload.password = password;

    setLoading(true);
    try {
      const res = await updateAccount(account.id, payload);
      if (res?.success) {
        onSuccess?.();
      } else {
        setError(res?.message || "فشل تحديث الحساب");
      }
    } catch (err) {
      setError(err?.message || "حدث خطأ أثناء التحديث");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>تعديل حساب العميل #{account?.id || ""}</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ mt: 1 }}>
          <TextField label="الاسم" value={name} onChange={(e) => setName(e.target.value)} fullWidth />
          <TextField label="البريد الإلكتروني" value={email} onChange={(e) => setEmail(e.target.value)} fullWidth />
          <TextField label="كلمة المرور (اتركها إن لم تغير)" type="password" value={password} onChange={(e) => setPassword(e.target.value)} fullWidth />
          <FormControl fullWidth size="small">
            <InputLabel>الدور</InputLabel>
            <Select value={role} label="الدور" onChange={(e) => setRole(e.target.value)}>
              {ROLE_OPTIONS.map((r) => (
                <MenuItem key={r.value} value={r.value}>{r.label}</MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl fullWidth size="small">
            <InputLabel>النوع</InputLabel>
            <Select value={type} label="النوع" onChange={(e) => setType(e.target.value)}>
              <MenuItem value="client">client</MenuItem>
              <MenuItem value="user">user</MenuItem>
            </Select>
          </FormControl>

          <FormControl fullWidth size="small">
            <InputLabel>الحالة</InputLabel>
            <Select value={status} label="الحالة" onChange={(e) => setStatus(e.target.value)}>
              <MenuItem value="1">مفعل</MenuItem>
              <MenuItem value="0">معطّل</MenuItem>
            </Select>
          </FormControl>

          {error && <Typography color="error">{error}</Typography>}
        </Stack>
      </DialogContent>

      <DialogActions>
        <Box sx={{ flex: 1 }} />
        <Button onClick={onClose} disabled={loading}>إلغاء</Button>
        <Button variant="contained" onClick={handleSubmit} disabled={loading}>
          {loading ? <CircularProgress size={18} /> : "حفظ"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditClientAccountDialog;
